import { Routes } from '@angular/router';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { authGuard } from './core/guards/auth_guard';
import { PrivateLayoutComponent } from './layouts/private-layout/private-layout.component';
import { adminGuard } from './core/guards/role_guard';

export const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./features/public/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'styleguide',
        loadComponent: () => import('./features/public/styleguide/styleguide.component').then(m => m.StyleguideComponent)
      },
      {
        path: 'properties',
        loadComponent: () => import('./features/public/properties/properties.component').then(m => m.PropertiesComponent)
      },
      {
        path: 'property/:propertyRef',
        loadComponent: () => import('./features/public/property/property.component').then(m => m.PropertyComponent)
      },
      {
        path: 'about',
        loadComponent: () => import('./features/public/about/about.component').then(m => m.AboutComponent)
      },
      {
        path: 'blog',
        loadComponent: () => import('./features/public/blog/blog.component').then(m => m.BlogComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./features/public/blog/blog.component').then(m => m.BlogComponent)
          },
          {
            path: 'post/:id',
            loadComponent: () => import('./features/public/blog/blog-post/blog-post.component').then(m => m.BlogPostComponent)
          }
        ]
      },
      {
        path: 'privacidad',
        loadComponent: () => import('./features/public/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
    ]
  },
  {
    path: 'login',
    loadComponent: () => import('./features/public/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./features/public/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: 'internal/inventory/:id/ficha',
    canActivate: [authGuard],
    loadComponent: () => import('./features/internal/property-technical-sheet/property-technical-sheet.component').then(m => m.PropertyTechnicalSheetComponent)
  },
  {
    path: 'internal',
    component: PrivateLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
          path: '',
          loadComponent: () => import('./features/internal/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'properties',
        loadComponent: () => import('./features/internal/create-property/internal-create-property.component').then(m => m.PropertyFormComponent)
      },
      {
        path: 'inventory/:id',
        loadComponent: () => import('./features/internal/properties-list/property-detail.component').then(m => m.PropertyDetailComponent)
      },
      {
        path: 'inventory',
        loadComponent: () => import('./features/internal/properties-list/internal-properties-list.component').then(m => m.InternalPropertiesListComponent)
      },
      {
        path: 'manage-content',
        canActivate: [adminGuard],
        loadComponent: () => import('./features/internal/content/content.component').then(m => m.ContentComponent)
      },
      {
        path: 'manage-users',
        canActivate: [adminGuard],
        loadComponent: () => import('./features/internal/manage-users/manage-users.component').then(m => m.ManageUsersComponent)
      },
      {
        path: 'manage-locations',
        canActivate: [adminGuard],
        loadComponent: () => import('./features/internal/manage-locations/manage-locations.component').then(m => m.ManageLocationsComponent)
      },
      {
        path: 'contacts',
        canActivate: [adminGuard],
        loadComponent: () => import('./features/internal/contacts/contacts-list/contacts-list.component').then(m => m.ContactsListComponent)
      },
      {
        path: 'contacts/:id',
        canActivate: [adminGuard],
        loadComponent: () => import('./features/internal/contacts/contact-detail/contact-detail.component').then(m => m.ContactDetailComponent)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
